/**
 * Decodes a picked photo off the main thread, draws it to an OFFSCREEN canvas
 * (never added to the DOM), resizes to maxEdge on the long side, and exports JPEG.
 * Strips EXIF from the stored file — GPS/time must be read BEFORE calling this.
 */
export async function transcodeToJpeg(
  file: File, maxEdge = 1600, quality = 0.85,
): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  try {
    const longEdge = Math.max(bitmap.width, bitmap.height);
    const scale = longEdge > maxEdge ? maxEdge / longEdge : 1;
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas 2D context unavailable.');
    ctx.drawImage(bitmap, 0, 0, w, h);

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob) throw new Error('Failed to encode JPEG.');
    return blob;
  } finally {
    bitmap.close();
  }
}
